// Debug:

GW.define('Debug.Screen', 'Main.Screen', {
	title: _('Debugovací panel'),
	titleIcon: 'bug',

	'after:initComponent'() {
		this.el.classList.add('debug-screen');
	},

	getSidebarMenu() {
		return [{
			nodeName: 'a',
			className: 'item',
			href: APP_BASE + 'debug/bugreports',
			textContent: _('Bugreporty'),
		}, {
			nodeName: 'a',
			className: 'item',
			href: APP_BASE + 'debug/calllogs',
			textContent: _('Logy mobilní aplikace'),
		}, {
			nodeName: 'a',
			className: 'item',
			href: APP_BASE + 'debug/logs',
			textContent: _('Logy v časové ose'),
		}, {
			nodeName: 'a',
			className: 'item',
			href: APP_BASE + 'debug/sipproxyregs',
			textContent: _('Registrované mobily'),
		}, {
			nodeName: 'a',
			className: 'item',
			href: APP_BASE + 'debug/state',
			textContent: _('Deep Backend'),
		}, {
			nodeName: 'a',
			className: 'item',
			href: APP_BASE + 'debug/calls',
			textContent: _('Hovory'),
		}, {
			':skip': !env.DEBUG_DBC_SCENARIOS,
			nodeName: 'a',
			className: 'item',
			href: APP_BASE + 'debug/scenarios',
			textContent: _('Scénáře'),
		}, {
			nodeName: 'a',
			className: 'item',
			href: APP_BASE + 'debug/loopback',
			textContent: _('Loopback log'),
		}];
	},
});

// {{{ Debug.CallsScreen

GW.define('Debug.CallsScreen', 'Debug.Screen', {
	'after:initComponent'() {
		this.bodyEl.gwReplaceChildren([{
			ref: 'calls',
			xtype: 'SmartTable',
			emptyText: _('Nic'),
			getColumns() {
				return [{
					id: 'id',
					name: _('Linked ID'),
					formatCell(td, v, row) {
						td.gwCreateChild({
							className: 'id',
							textContent: v,
						});

						td.gwCreateChild({
							className: 'time',
							textContent: Formats.datetime(row.ts),
						});
					},
				}];
			},
			selectable: true,
			onRowClick: async (row, tr, ev) => {
				this.calls.selectRow(r => row === r);

				row.events = await this.getCallEvents(row.id);

				this.renderCall(row);
			},
		}, {
			className: 'detail',
			ref: 'detailCt',
			children: [{
				nodeName: 'canvas',
				ref: 'canvas',
			}, {
				ref: 'labelsOverlayEl',
				className: 'labels',
			}],
		}], this);
	},

	async getCallEvents(id) {
		return await REST.GET('debug/calls/events', {linkedid: id});
	},

	renderCall(call) {
		let start_ts = call.events[0].ts;
		let end_ts = call.events[call.events.length - 1].ts;
		let total_time = end_ts - start_ts;
		let ev_count = call.events.length;

		let channel_props = new Set([
			'Channel',
			'DestChannel',
			'LocalOneChannel',
			'LocalTwoChannel',
			'OrigTransfererChannel',
			'SecondTransfererChannel',
			'SourceChannel',
			'TransfereeChannel',
			'TransfererChannel',
			'TransferTargetChannel',
		]);

		let channels = call.events.reduce((list, e) => {
			for (let [k, v] of Object.entries(e)) {
				if (!e._chans) {
					e._chans = new Set;
				}

				if (channel_props.has(k)) {
					list.add(v);
					e._chans.add(v);
				}
			}
			return list;
		}, new Set);

		let next_color = 0;
		let bridges = {};
		let ch_info = {};
		let max_ch_ev_count = 0;
		for (let ch of channels) {
			let chi = ch_info[ch] = {};

			chi.events = call.events.filter(e => e._chans.has(ch)).map(e => ({...e, ts: e.ts - start_ts}));
			chi.start_ts = chi.events[0].ts;
			chi.end_ts = chi.events[chi.events.length - 1].ts;
			chi.bridge_segs = [];

			max_ch_ev_count = Math.max(max_ch_ev_count, chi.events.length);

			let ch_bridges = {};
			for (let e of chi.events) {
				if (e.Event == 'BridgeEnter') {
					if (!bridges[e.BridgeUniqueid]) {
						bridges[e.BridgeUniqueid] = {
							id: e.BridgeUniqueid,
							color: `hsl(${next_color}, 100%, 50%)`,
						};

						next_color = (next_color + 50) % 360;
					}

					let b = bridges[e.BridgeUniqueid];
					ch_bridges[b.id] = e.ts;
				} else if (e.Event == 'BridgeLeave') {
					let b = bridges[e.BridgeUniqueid];
					if (b) {
						if (ch_bridges[b.id] === undefined) {
							continue;
						}

						chi.bridge_segs.push({
							bridge: bridges[b.id],
							start: ch_bridges[b.id],
							end: e.ts
						});

						delete ch_bridges[b.id];
					}
				}
			}
		}

		let chan_w = 720;

		let w = this.canvas.width = Math.max(chan_w * (channels.size + 0.5), this.detailCt.clientWidth);
		let h = this.canvas.height = Math.max(max_ch_ev_count * 30, this.detailCt.clientHeight - 5);

		this.labelsOverlayEl.style.width = w + 'px';
		this.labelsOverlayEl.style.height = h + 'px';

		let scroll_h = h;

		let c = this.canvas.getContext('2d');

		// clear canvas
		c.fillStyle = '#fff';
		c.fillRect(0, 0, w, h);

		c.fillStyle = '#ccc';
		c.fillRect(0, 0, w, 26);

		// draw channel lines and names

		let labels = [];
		let col = 0;
		for (let ch of channels) {
			let info = ch_info[ch];

			// channel column
			c.save();
			c.translate(col * chan_w, 0);

			// title
			c.save();
			c.fillStyle = 'black';
			c.textBaseline = 'hanging';
			c.font = 'bold 12px sans-serif';
			c.textAlign = 'center';
			c.fillText(ch, chan_w / 2, 10, chan_w);
			c.restore();

			let timeline_pad_top = 40;
			let timeline_pad_bottom = 140;

			// draw channel line
			let y_scale = (scroll_h - timeline_pad_top - timeline_pad_bottom) / total_time;

			let next_avail_y = 0;

			c.save();
			c.translate(0, timeline_pad_top);
			c.fillStyle = '#aac';
			c.fillRect(chan_w / 2 - 15, info.start_ts * y_scale, 30, (info.end_ts - info.start_ts) * y_scale);

			c.fillStyle = '#aac';
			c.fillRect(chan_w / 2, 0, 1, y_scale * total_time);

			for (let ev of info.events) {
				let y = ev.ts * y_scale - 1;

				// event marker
				c.fillStyle = '#88a';
				c.fillRect(chan_w / 2 - 40, y, 80, 2);

				let text_y_space = 13;
				let text_off = 50;
				let text_y = y;
				if (y < next_avail_y) {
					text_y = next_avail_y;
					next_avail_y += text_y_space;
				} else {
					next_avail_y = y + text_y_space;
				}

				let text = ev.Event;
				if (ev.Event == 'CEL') {
					text += ':' + ev.EventName;
				} else if (ev.Event == 'Newexten') {
					text += ':' + ev.Context + ':' + ev.Extension + ':' + ev.Priority + ':' + ev.Application + '(' + ev.AppData + ')';
				} else if (ev.Event == 'NewCallerid') {
					text += ':' + ev.CallerIDNum + ' (' + ev.CallerIDName + ')';
				} else if (ev.Event == 'NewConnectedLine') {
					text += ':' + ev.ConnectedLineNum + ' (' + ev.ConnectedLineName + ')';
				} else if (ev.Event == 'DialBegin') {
					text += ':' + ev.DialString + ' ch=' + ev.DestChannel;
				} else if (ev.Event == 'DialState') {
					text += ':' + ev.DialStatus + ' ch=' + ev.DestChannel;
				} else if (ev.Event == 'DialEnd') {
					text += ':' + ev.DialStatus + ' ch=' + ev.DestChannel;
				} else if (ev.Event == 'Newstate') {
					text += ':' + ev.ChannelStateDesc;
				} else if (ev.Event == 'QueueCallerJoin') {
					text += ':' + ev.Queue + ' pos=' + ev.Position + ' count=' + ev.Count;
				} else if (ev.Event == 'QueueCallerLeave') {
					text += ':' + ev.Queue + ' pos=' + ev.Position + ' count=' + ev.Count;
				} else if (ev.Event == 'AgentCalled') {
					text += ':' + ev.Queue + ' interface=' + ev.Interface + ' member=' + ev.MemberName;
				} else if (ev.Event == 'AgentConnect') {
					text += ':' + ev.Queue + ' interface=' + ev.Interface + ' member=' + ev.MemberName + ' holdtime=' + ev.HoldTime + ' ringtime=' + ev.RingTime;
				} else if (ev.Event == 'DTMFBegin') {
					text += ':' + ev.Direction + ' ' + ev.Digit;
				} else if (ev.Event == 'DTMFEnd') {
					text += ':' + ev.Direction + ' ' + ev.Digit + ' dur=' + ev.DurationMs + 'ms';
				} else if (ev.Event == 'BridgeEnter') {
					text += ':' + ev.BridgeUniqueid;
				} else if (ev.Event == 'BridgeLeave') {
					text += ':' + ev.BridgeUniqueid;
				} else if (ev.Event == 'SoftHangupRequest') {
					text += ':' + 'cause=' + ev.Cause;
				} else if (ev.Event == 'Hangup') {
					text += ':' + 'cause=' + ev['Cause-txt'];
				} else if (ev.Event == 'RTCPSent') {
					text += ':' + ev.PT + ' ' + ev.From + ' -> ' + ev.To + ' lost=' + (ev.Report0CumulativeLost || '') + ' sent=' + (ev.SentPackets || '');
				} else if (ev.Event == 'RTCPReceived') {
					text += ':' + ev.PT + ' ' + ev.From + ' -> ' + ev.To + ' lost=' + (ev.Report0CumulativeLost || '') + ' sent=' + (ev.SentPackets || '');
				}

				// line to event text
				c.save();
				c.strokeStyle = '#aaa';
				c.beginPath();
				c.moveTo(chan_w / 2 + 40, y);
				c.lineTo(chan_w / 2 + 40 + text_off - 3, text_y);
				c.stroke();
				c.restore();

				c.save();
				c.fillStyle = 'black';
				c.textBaseline = 'middle';
				c.font = '12px sans-serif';
				c.textAlign = 'left';
				c.fillText(text, chan_w / 2 + 40 + text_off, text_y);

				// we don't do scaling, so this works
				let t = c.getTransform();
				let m = c.measureText(text);
				labels.push({
					x: t.e + chan_w / 2 + 40 + text_off,
					y: t.f + text_y - 7,
					w: m.width,
					h: 14,
					ev,
					text: JSON.stringify(ev, null, '    '),
				});

				c.restore();
			}

			for (let br_seg of info.bridge_segs) {
				let rect = {
					x: chan_w / 2 - 20,
					y: br_seg.start * y_scale,
					w: 40,
					h: (br_seg.end - br_seg.start) * y_scale,
				};

				c.save();
				c.fillStyle = br_seg.bridge.color;
				c.fillRect(rect.x, rect.y, rect.w, rect.h);
				c.restore();

				// we don't do scaling, so this works
				let t = c.getTransform();
				labels.push({
					x: t.e + rect.x,
					y: t.f + rect.y,
					w: rect.w,
					h: rect.h,
					bridge: br_seg.bridge,
					text: JSON.stringify({
						bridge: br_seg.bridge.id,
					}, null, '    '),
				});
			}

			c.restore();

			c.restore();

			col++;
		}

		this.labelsOverlayEl.gwReplaceChildren(labels.map(l => {
			return {
				className: 'label',
				style: `top: ${l.y}px; left: ${l.x}px; width: ${l.w}px; height: ${l.h}px;`,
				'on:mouseenter': ev => {
					let popup = document.gwCreateElement({
						className: 'debug-popup',
						textContent: l.text,
					});

					PopupManager.show(popup, {
						anchorEl: ev.target,
					});
				},
				'on:mouseleave': ev => {
					PopupManager.hideAll();
				},
				'on:click': ev => {
					alert(l.text);
				},
			};
		}));
	},

	setData(calls) {
		this.calls.setData(calls);
	},
});

// }}}
// {{{ Debug.StateScreen

GW.define('Debug.StateScreen', 'Debug.Screen', {
	renderExtensions() {
		return [{
			nodeName: 'h2',
			textContent: _('Linky'),
		}, {
			ref: 'extensionsTable',
			xtype: 'SmartTable',
			emptyText: _('Nic'),
			renderRow(tr, row) {
				tr.dataset.json = JSON.stringify(row, null, '  ');
			},
			getColumns() {
				return [{
					id: 'extension',
					name: _('Linka'),
				}, {
					id: 'available',
					name: _('Stav'),
					formatCell(td, v, row) {
						td.textContent = v ? 'available' : 'unavailable';
						td.dataset.status = v ? 'available' : 'unavailable';
					},
				}, {
					id: 'devices',
					name: _('Zařízení'),
					formatCell(td, v, row) {
						for (let d of v) {
							td.gwCreateChild({
								className: 'device',
								children: [{
									className: 'id',
									textContent: d.endpoint,
								}, {
									className: 'kind',
									textContent: d.kind,
								}, {
									className: 'status',
									textContent: d.reachable ? 'reachable' : 'unreachable',
									'attr:data-status': d.reachable ? 'reachable' : 'unreachable',
								}]
							});
						}
					},
				}];
			},
		}];
	},

	renderChannels() {
		let timeCell = this.timeCell.bind(this);

		return [{
			nodeName: 'h2',
			textContent: _('Kanály'),
		}, {
			ref: 'channelsTable',
			xtype: 'SmartTable',
			emptyText: _('Nic'),
			renderRow(tr, row) {
				tr.dataset.json = JSON.stringify(row, null, '  ');
			},
			getColumns() {
				return [{
					id: 'first_time',
					name: _('Vznikl'),
					formatCell: timeCell,
				}, {
					id: 'channel',
					name: _('Kanál'),
				}, {
					id: 'state',
					name: _('Stav'),
					formatCell(td, v, row) {
						td.setAttribute('data-state', v);
						td.textContent = v + (row.hold_start_ts ? ' hold' : '') + (row.musichold ? ' musichold' : '');
					},
				}, {
					id: 'caller',
					name: _('Volající'),
				}, {
					id: 'connected_line',
					name: _('Spojená linka'),
				}, {
					id: 'queue',
					name: _('Fronta'),
				}, {
					id: 'linked_id',
					name: _('Linked ID'),
				}];
			},
		}];
	},

	renderConnections() {
		let timeCell = this.timeCell.bind(this);

		return [{
			nodeName: 'h2',
			textContent: _('Spojení'),
		}, {
			ref: 'connectionsTable',
			xtype: 'SmartTable',
			emptyText: _('Nic'),
			renderRow(tr, row) {
				tr.dataset.json = JSON.stringify(row, null, '  ');
			},
			getColumns() {
				return [{
					id: 'dial_ts',
					name: _('Vytáčení'),
					formatCell: timeCell,
				}, {
					id: 'ring_ts',
					name: _('Vyzvánění'),
					formatCell: timeCell,
				}, {
					id: 'start_ts',
					name: _('Hovor začal'),
					formatCell: timeCell,
				}, {
					id: 'external',
					name: _('Druh'),
				}, {
					id: 'caller',
					name: _('Volající'),
					formatCell(td, v, row) {
						td.gwReplaceChildren([{
							nodeName: 'span',
							className: 'name',
							textContent: v,
						}, ' - ', {
							nodeName: 'span',
							className: 'channel',
							textContent: row.channel_caller ? row.channel_caller.channel : '',
						}, ' - ', {
							nodeName: 'span',
							className: 'state',
							'attr:data-state': row.channel_caller ? row.channel_caller.state : '',
							textContent: row.channel_caller ? row.channel_caller.state : '',
						}]);
					},
				}, {
					id: 'callee',
					name: _('Volaný'),
					formatCell(td, v, row) {
						td.gwReplaceChildren([{
							nodeName: 'span',
							className: 'name',
							textContent: v,
						}, ' - ', {
							nodeName: 'span',
							className: 'channel',
							textContent: row.channel_callee ? row.channel_callee.channel : '',
						}, ' - ', {
							nodeName: 'span',
							className: 'state',
							'attr:data-state': row.channel_callee ? row.channel_callee.state : '',
							textContent: row.channel_callee ? row.channel_callee.state : '',
						}]);
					},
				}, {
					id: 'queue',
					name: _('Fronta'),
				}];
			},
		}];
	},

	renderQueues() {
		return [{
			nodeName: 'h2',
			textContent: _('Fronty'),
		}, {
			ref: 'queuesTable',
			xtype: 'SmartTable',
			emptyText: _('Nic'),
			renderRow(tr, row) {
				tr.dataset.json = JSON.stringify(row, null, '  ');
			},
			getColumns() {
				return [{
					id: 'queue',
					name: _('Fronta'),
				}, {
					id: 'agents',
					name: _('Agenti'),
					formatCell(td, v, row) {
						for (let a of v) {
							td.gwCreateChild({
								className: 'agent',
								children: [{
									className: 'exten',
									textContent: a.exten,
								}, {
									className: 'interface',
									textContent: a.interface,
								}, {
									className: 'paused',
									textContent: a.paused ? 'paused' : '',
								}]
							});
						}
					},
				}];
			},
		}];
	},

	timeCell(td, v) {
		td.textContent = this.formatTime(v);
	},

	formatTime(ts) {
		if (ts == null) {
			return '';
		}

		if (!(ts instanceof Date)) {
			ts = new Date(ts);
		}

		return this.timeFmt.format(ts) + '.' + ts.getMilliseconds();
	},

	'after:initComponent'() {
		this.el.classList.add('js-msgbus');
		this.el.socketSubscriptions = ['debug'];

		this.timeFmt = new Intl.DateTimeFormat('cs-CZ', {
			year: 'numeric', month: 'numeric', day: 'numeric',
			hour: 'numeric', minute: 'numeric', second: 'numeric',
		});

		this.bodyEl.gwReplaceChildren([{
			className: 'toolbar',
			children: [{
				nodeName: 'button',
				className: 'primary',
				textContent: _('Obnovit data'),
				'on:click': ev => this.reload(),
			}],
		}, {
			className: 'detail',
			ref: 'detailCt',
			'on*:mouseenter': ev => {
				let el = ev.target.closest('[data-json]');
				if (el) {
					PopupManager.hideAll();

					let popup = document.gwCreateElement({
						className: 'debug-json-popup',
						textContent: el.getAttribute('data-json'),
					});

					PopupManager.show(popup, {
						anchorEl: ev.target,
					});
				}
			},
			'on*:mouseleave': ev => {
				PopupManager.hideAll();
			},
			'on*:click': ev => {
				let el = ev.target.closest('[data-json]');
				if (el) {
					alert(el.getAttribute('data-json'));
				}
			},
			children: [
				...this.renderChannels(),
				...this.renderConnections(),
				...this.renderExtensions(),
				...this.renderQueues(),
			],
		}], this);
	},

	onBusMessage(msg) {
		if (msg.type == 'DBC_STATE_CHANGED') {
			Utils.dedupeCalls(this, 'reload', 500, () => this.reload());
		}
	},

	async reload() {
		let signal = Utils.abortAndRetry(this, 'reload');
		let state = await REST.GET('debug/state', null, {signal});

		this.extensionsTable.setData(state.extensions);
		this.connectionsTable.setData(state.connections);
		this.channelsTable.setData(state.channels);
		this.queuesTable.setData(state.queues);
	},
});

// }}}
// {{{ Debug.LoopbackScreen

GW.define('Debug.LoopbackScreen', 'Debug.Screen', {
	'after:initComponent'() {
		this.el.classList.add('js-msgbus');
		this.el.socketSubscriptions = ['debug'];

		this.bodyEl.gwReplaceChildren([{
			nodeName: 'h2',
			textContent: _('Log události z POST /api/debug/loopback'),
		}, {
			ref: 'listCt',
			className: 'event-list',
		}], this);
	},

	renderMessage(body) {
		this.listCt.gwCreateChild({
			className: 'event',
			textContent: Formats.datetime(Date.now() / 1000) + ':\n' + JSON.stringify(body, null, '    '),
		});
	},

	onBusMessage(msg) {
		if (msg.type == 'DEBUG_LOOPBACK') {
			this.renderMessage(msg.body);
		}
	},
});

// }}}
// {{{ Debug.BugreportsScreen

GW.define('Debug.BugreportsScreen', 'Debug.Screen', {
	'after:initComponent'() {
		this.bodyEl.gwReplaceChildren([{
			className: 'toolbar',
			children: [],
		}, {
			ref: 'table',
			xtype: 'SmartTable',
			emptyText: _('Nic'),
			getColumns() {
				return [{
					id: 'time',
					name: _('Čas'),
					formatCell(td, v, row) {
						let ts = row.file_name.match(/^\d+/);
						if (ts) {
							td.textContent = Formats.datetime(ts[0] / 1000);
						}
					},
				}, {
					id: 'file_name',
					name: _('Soubor'),
					formatCell(td, v, row) {
						td.gwCreateChild({
							nodeName: 'a',
							href: API_BASE + 'debug/bugreports/' + encodeURIComponent(v),
							download: v,
							textContent: v,
						});
					},
				}, {
					id: 'message',
					name: _('Zpráva'),
				}, {
					id: 'ua',
					name: _('Agent'),
				}, {
					id: 'user_extension',
					name: _('Linka'),
				}, {
					id: 'user_name',
					name: _('Uživatel'),
				}, {
					id: 'user_email',
					name: _('E-mail'),
				}];
			},
		}], this);
	},

	async applyParams(params) {
		let signal = Utils.abortAndRetry(this, 'reload');
		let list = await REST.GET('debug/bugreports', null, {signal});

		this.table.setData(list);
	},
});

// }}}
// {{{ Debug.CallLogsScreen

GW.define('Debug.CallLogsScreen', 'Debug.Screen', {
	'after:initComponent'() {
		this.bodyEl.gwReplaceChildren([{
			className: 'toolbar',
			children: [],
		}, {
			ref: 'table',
			xtype: 'SmartTable',
			emptyText: _('Nic'),
			getColumns() {
				return [{
					id: 'time',
					name: _('Čas'),
					formatCell(td, v, row) {
						let ts = row.file_name.match(/^\d+/);
						if (ts) {
							td.textContent = Formats.datetime(ts[0] / 1000);
						}
					},
				}, {
					id: 'file_name',
					name: _('Soubor'),
					formatCell(td, v, row) {
						td.gwCreateChild({
							nodeName: 'a',
							href: API_BASE + 'debug/calllogs/' + encodeURIComponent(v),
							download: v,
							textContent: v,
						});
					},
				}, {
					id: 'call_id',
					name: _('ID hovoru'),
				}, {
					id: 'user_name',
					name: _('Uživatel'),
				}, {
					id: 'user_email',
					name: _('E-mail'),
				}, {
					id: 'user_extension',
					name: _('Linka'),
				}];
			},
		}], this);
	},

	reload() {
		return this.applyParams(location.searchParams);
	},

	async applyParams(params) {
		let signal = Utils.abortAndRetry(this, 'reload');
		let list = await REST.GET('debug/calllogs', null, {signal});

		this.table.setData(list);
	},
});

// }}}
// {{{ Debug.MobileRegistrationsScreen

GW.define('Debug.MobileRegistrationsScreen', 'Debug.Screen', {
	'after:initComponent'() {
		this.bodyEl.gwReplaceChildren([{
			className: 'toolbar',
			children: [],
		}, {
			ref: 'table',
			xtype: 'SmartTable',
			emptyText: _('Nic'),
			getColumns() {
				return [{
					id: 'username',
					name: _('Linka'),
				}, {
					id: 'user_agent',
					name: _('Agent'),
				}, {
					id: 'ip_addr',
					name: _('IP adresa'),
				}, {
					id: 'last_modified',
					name: _('Čas registrace'),
					formatCell(td, v, row) {
						td.textContent = Formats.datetime(Date.parse(v) / 1000);
					},
				}, {
					id: 'device',
					name: _('ID zařízení'),
				}];
			},
		}], this);
	},

	async applyParams(params) {
		let signal = Utils.abortAndRetry(this, 'reload');
		let list = await REST.GET('debug/sipproxyregs', null, {signal});

		this.table.setData(list);
	},
});

// }}}
// {{{ Debug.LogsScreen

GW.define('Debug.LogsScreen.TimeLine', 'GW.Component', {
	
	categories: {}, // {category, color}
	
	arguments: {
		type: '',
		metadata: '',
	},
	
	entries_unfiltered: null,
	entries: null,
	filter: null, // filter used to convert entries_unfiltered to entries
	
	show_unfiltered: true,
	
	view_mode: 'time', // 'time', 'index'
	
	scroll_position: 0.5, // 0..1 as scroll position, for view_mode === 'time', time-based
	index_position: 0, // index in the entry in the middle of the screen, for view_mode === 'index'

	zoom_fraction: 1, // how big part is visible in the view port, only for view_mode = 'time' ignored for 'index'
	
	line_height: 12,

	initComponent() {
		this.el = document.gwCreateElement({
			ref: 'wrapEl',
			className: 'logs-wrap',
			$key_Escape: () => {
				this.metadataDetail?.classList.add('hidden');
			},
			children: [{
				className: 'metadata',
				children: [{
					className: 'summary',
					children: [{
						ref: 'metadataSummaryEl',
					}, {
						nodeName: 'button',
						className: 'secondary small icon-right',
						children: [_('Metadata'), Utils.useIcon('arrow-down')],
						'on:click': () => {
							if (!this.metadataDetail.classList.toggle('hidden')) {
								this.renderMetadata();
							}
						}
					}, {
						nodeName: 'button',
						className: 'secondary small icon-right',
						children: [_('Hovory'), Utils.useIcon('arrow-down')],
						'on:click': () => {
							if (!this.metadataDetail.classList.toggle('hidden')) {
								this.renderCalls();
							}
						}
					}]
				}, {
					className: 'detail hidden',
					ref: 'metadataDetail',
				}],
			}, {
				className: 'toolbar',
				children: [{
					ref: 'searchInputEl',
					nodeName: 'input',
					type: 'search',
					className: 'search small',
					placeholder: _('Hledat'),
					'on:input': ev => {
						this.updateFilter();
					},
				}, {
					ref: 'filterCategoryEl',
					className: 'filter-category',
					children: [], // filled in setCategories(), categories are platform specific
				}, {
					xtype: 'Widgets.ButtonSwitcher',
					className: 'button-switcher small',
					items: [{
						id: 'time',
						title: _('Podle času'),
					}, {
						id: 'index',
						title: _('Podle pořadí'),
					}],
					'on:beforeselect': (c, i) => {
						this.view_mode = i.id;
						c.setSelected(i.id);
						// recompute position to show the data in the viewport (same entry in the middle, zoom might differ)
						const entries = this.entries_unfiltered;
						if (i.id === 'time') {
							this.scroll_position = (entries[this.index_position].ts - entries[0].ts) / (entries.at(-1).ts - entries[0].ts);
						}
						if (i.id === 'index') {
							this.index_position = this.ts_to_index(entries[0].ts + this.scroll_position * (entries.at(-1).ts - entries[0].ts), entries);
						}
						this.updateUI();
					},
					'after:initComponent'() {
						this.setSelected('time');
					}
				}, {
					className: 'check',
					children: [{
						id: 'filter-show-unfiltered',
						nodeName: 'input',
						className: 'small',
						type: 'checkbox',
						checked: this.show_unfiltered,
						'on:input': e => {
							this.show_unfiltered = e.target.checked;
							this.updateFilter();
						},
					}, {
						nodeName: 'label',
						htmlFor: 'filter-show-unfiltered',
						textContent: _('Zobrazit odfiltrované'),
					}],
				}]
			}, {
				ref: 'viewPortEl',
				className: 'viewport hidden',
				children: [{
					ref: 'entriesEl',
					className: 'entries',
					children: [{
						ref: 'linesEl',
						className: 'lines',
						'on:click': () => {
							if (this.itemPopupEl) {
								this.itemPopupEl.remove()
							}
						},
					}], // here the popup is added
				}, {
					ref: 'minimapEl',
					className: 'minimap',
					children: [{
						ref: 'minimapCanvasEl',
						className: 'minimap-canvas',
						nodeName: 'canvas',
					}, {
						ref: 'scrollHandleEl',
						className: 'scroll-handle',
					}],
					'on:mousemove'(e) {
						if (e.buttons & 0x1) {
							this.scrollWithY(e.offsetY);
						}
					},
					'on:click'(e)  {
						if (e.button == 0) {
							this.scrollWithY(e.offsetY);
						}
					},
					scrollWithY: y => {
						// view is time based, scroll bar is time based, use it as is
						this.scroll_position = y / this.minimapEl.offsetHeight;
						const entries = this.entries_unfiltered;
						this.index_position = this.ts_to_index(entries[0].ts + this.scroll_position * (entries.at(-1).ts - entries[0].ts), entries);
						console.log("New index position: " + this.index_position + " , from scroll position " + this.scroll_position);
						this.updateUI();
					}
				}],
				tabIndex: '-1',
				$key_Escape: () => {
					if (this.itemPopupEl) {
						this.itemPopupEl.remove();
					}
				},
			}, {
				ref: 'noEntriesEl',
				className: 'no-entries',
				children: [this.renderNoEntries()],
			}], 
		}, this);
		let mouseY = 0; // TODO: skew zoom change with regard to mouseY
		this.viewPortEl.addEventListener('wheel', e => {
			let sgn = Math.sign(e.deltaY)
			if (e.ctrlKey) {
				e.preventDefault();
				if (this.view_mode === 'time') {
					this.zoom_fraction = Math.max(0, Math.min(1, this.zoom_fraction * (1 + sgn / 20)));
					this.updateZoom();
				}
			} else {
				if (this.view_mode === 'time') {
					this.scroll_position += this.zoom_fraction * sgn / 30;	
				} else {
					this.index_position += 2 * sgn;
				}
				this.updateZoom();
			}
		});
		this.viewPortEl.addEventListener('mousemove', e => mouseY = e.pageY - this.viewPortEl.getBoundingClientRect().top);
	},

	renderNoEntries() {
		return {};	
	},
	
	setCategories(categories) {
		this.categories = categories;
		
		this.filterCategoryEl.gwReplaceChildren(categories.map(category => ({
			textContent: category.id,
			'attr:data-id': category.id,
			style: {
				background: category.color
			},
			'on:click': (e) => {
				e.target.classList.toggle('active');
				this.updateFilter();
			}
		})));
	},
	
	updateFilter() {
		const q = this.searchInputEl.value || '';
		const categories = [...this.filterCategoryEl.querySelectorAll('.active')].map(el => el.dataset.id);
		
		if (!q && categories.length == 0) {
			this.setFilter(null);
			return;
		}

		const q_filter = q ?
			e => (e.tag && e.tag.includes(q)) || e.message.includes(q) || e.short.includes(q) || (e.category || '').includes(q) :
			() => false;
		
		const category_filter = categories.length ?
			e => categories.includes(e.category) :
			() => false;
		
		this.setFilter(e => q_filter(e) || category_filter(e));
	},
	
	updateZoom() {		
		if (this.itemPopupEl) {
			// zoom invalidates its position, remove the popup (or recompute position?)
			this.itemPopupEl.remove();
		}
		this.updateUI(); // call async, no need to wait
	},
	
	renderMetadata() {
		const {metadata} = this.arguments;
		this.metadataDetail.gwReplaceChildren([{
			nodeName: 'pre',
			textContent: JSON.stringify(metadata, null, 4),
		}]);
	},
	
	renderCalls() {

		// Extract calls from entries - group by linked_id or call_id
		const calls = new Map();

		this.entries_unfiltered.forEach((entry, index) => {
			// Look for call-related entries (adjust these conditions based on your log structure)
			const callId = entry.data?.callId;
			if (!callId) {
				return;
			}
			if (!calls.has(callId)) {
				calls.set(callId, {
					id: callId,
					call_id: entry.data?.call_id,
					peer: entry.data?.peer,
					start_time: entry.ts,
					end_time: entry.ts,
					start_index: index,
					end_index: index,
					events_count: 1,
				});
			} else {
				const call = calls.get(callId);
				call.call_id ??= entry.data?.call_id;
				call.peer = entry.data?.peer || call.peer;
				call.end_time = Math.max(call.end_time, entry.ts);
				call.end_index = Math.max(call.end_index, index);
				call.events_count++;
			}
		});

		const calls_list = Array.from(calls.values()).sort((a, b) => a.start_time - b.start_time);
		
		console.log(calls_list);

		this.metadataDetail.gwReplaceChildren([{
			classList: 'call-list',
			children: calls_list.map(call => ({
				className: 'call-item',
				'data-call-id': call.id,
				'on:click': () => this.scrollToCall(call),
				children: [{
					className: 'call-time',
					textContent: new Date(call.start_time).toLocaleTimeString(),
				}, {
					className: 'call-peer',
					textContent: call.peer,
				}, {
					className: 'call-call_id',
					textContent: call.call_id,
				}, {
					className: 'call-duration',
					textContent: Formats.duration(call.end_time - call.start_time),
				}],
			})),
		}]);
	},
	
	scrollToCall(call) {
		// Calculate the position to show the entire call in viewport
		const entries = this.entries_unfiltered;
		const totalTime = entries.at(-1).ts - entries[0].ts;
		const callDuration = call.end_time - call.start_time;

		if (this.view_mode === 'time') {
			// Position the call so it's centered in the viewport
			const callCenter = call.start_time + (callDuration / 2);
			this.scroll_position = (callCenter - entries[0].ts) / totalTime;

			// Make the call take up 80% of the viewport
			this.zoom_fraction = Math.min(1, callDuration / (totalTime * 0.8));
		} else {
			// For index mode, position to show the call
			this.index_position = call.start_index + Math.floor((call.end_index - call.start_index) / 2);
		}

		this.updateUI();
	},
	
	setEntries(type, metadata, entries) {
		
		this.arguments = {type, metadata};
		
		this.metadataSummaryEl.textContent = type + ': ' + {
			'calllog': metadata.user?.name + ", " + metadata.call?.call_id + ", " + metadata.call?.peer + ', ' + metadata.call?.direction,
			'bugreport': metadata.message,
		}[type];		
		
		this.filter = null; // TODO reset UI filter
		this.entries_unfiltered = entries;
		this.entries = entries;

		if (!this.entries || this.entries.length == 0) {
			this.linesEl.textContent = '';
			this.viewPortEl.classList.add('hidden');
			this.noEntriesEl.classList.remove('hidden');
			return;
		}
		this.viewPortEl.classList.remove('hidden');
		this.noEntriesEl.classList.add('hidden');
		
		// set initial zoom to show all logs at once
		this.zoom_fraction = 1;
		this.scroll_position = 0;
		
		this.updateZoom();
		this.updateMinimap();
	},
	
	setFilter(filter) {
		this.filter = filter;
		if (this.show_unfiltered || !filter) {
			this.entries = this.entries_unfiltered;
		} else {
			this.entries = this.entries_unfiltered.filter(filter);
		}
		this.updateUI();
		this.updateMinimap();
	},
	
	groupEntriesByTime(entries, ts_first, ts_view, viewport_height, max_ts_diff = null) {
		if (entries.length == 0) {
			return [];
		}
		
		if (!max_ts_diff) {
			const zoom = ts_view / viewport_height;
			max_ts_diff = this.line_height * zoom;
		}
		
		const items = [];

		let last_item = null;
		for (const e of entries) {
			if (last_item == null || e.ts - last_item.ts > max_ts_diff) {
				if (last_item) {
					items.push(last_item);
				}
				last_item = e;
			} else {
				if (last_item && last_item.type === 'group') {
					// just add to previous group
					last_item.entries.push(e);
				} else {
					// create group from previous item
					last_item = {
						ts: e.ts,
						type: 'group',
						entries: last_item ? [last_item, e] : [e],
					}
				}
			}
		}
		if (last_item) {
			items.push(last_item);
		}
		
		return items.map(item => {
			const position = ((item.ts - ts_first) / ts_view) * viewport_height;
			return {...item, position};
		})
	},
	
	ts_to_index(ts, entries) {
		console.log({ts});
		// use binary search to find index of ts in entries
		let lo = -1, hi = entries.length;
		while (1 + lo < hi) {
			const mi = lo + ((hi - lo) >> 1);
			if (entries[mi].ts < ts) {
				lo = mi;
			} else {
				hi = mi;
			}
		}
		return lo;
	},
	
	async updateUI() {
		if (this.entries_unfiltered == null) {
			// no entries loaded
			return;
		}
		
		if (this.entries_unfiltered.length == 0) {
			this.linesEl.textContent = '';
			return;
		}

		// scrollbar values, dependent on visibility check
		let scroll_first, scroll_height;

		const viewport_height = this.linesEl.offsetHeight;

		// needed for scrollbar handle
		const ts_first = this.entries_unfiltered[0].ts;
		const ts_last = this.entries_unfiltered[this.entries_unfiltered.length - 1].ts;
		const ts_len = ts_last - ts_first;
		
		if (this.view_mode == 'time') {
			// show visible entries (time based)
			const ts_mid = this.scroll_position * ts_len;
			const ts_view = this.zoom_fraction * ts_len;

			const ts_start = ts_first + (ts_mid - ts_view / 2);
			const ts_end = ts_first + (ts_mid + ts_view / 2);

			const visible_entries = this.entries.filter(e => e.ts >= ts_start && e.ts < ts_end);

			scroll_first = (ts_start - ts_first) / ts_len;
			scroll_height = ts_view / ts_len;

			const items = this.groupEntriesByTime(visible_entries, ts_start, ts_view, viewport_height);

			this.linesEl.gwReplaceChildren(items.map(item => {
				return this.renderItem(item, item.position);
			}));
		}
		
		if (this.view_mode == 'index') {

			const entries = this.entries_unfiltered;

			// show visible entries (count based)
			let count_mid = this.index_position;
			
			count_mid = Math.max(0, Math.min(entries.length - 1, count_mid));

			const count_view = viewport_height / this.line_height;
			
			const count_first_i = Math.max(0, count_mid - count_view / 2);
			const count_last_i = Math.min(entries.length - 1, count_mid + count_view / 2);
			
			const visible_entries = entries.slice(count_first_i, count_last_i); 

			if (visible_entries.length == 0) {
				this.linesEl.textContent = '';
			} else {

				const scroll_ts_len = visible_entries.at(-1).ts - visible_entries[0].ts;

				scroll_first = (visible_entries[0].ts - ts_first) / ts_len;
				scroll_height = scroll_ts_len / ts_len;

				this.linesEl.gwReplaceChildren(visible_entries.map((item, i) => {
					return this.renderItem(item, i * this.line_height);
				}));
			}
		}

		// render scrollbar
		const minimap_height = this.minimapEl.offsetHeight;
		this.scrollHandleEl.style.top = (scroll_first * minimap_height) + 'px';
		this.scrollHandleEl.style.height = (scroll_height * minimap_height) + 'px';
	},
	
	// bigger = more important
	getEntryOrder(entry) {
		let p = 0;
		if (this.filterHighlight(entry)) {
			p += 1000;
		}
		if (entry.show_priority) {
			return p + entry.show_priority;
		}
		const priorities = 'VDIWEF'.split('');
		return p + priorities.indexOf(entry.priority);
	},
	
	filterHighlight(entry) {
		return this.show_unfiltered && this.filter && this.filter(entry);
	},
	
	renderItem(item, position) {
		
		let line;

		if (item.type == 'space') {
			// render spacing item
			let ratio = item.space_ratio; // relative to the all items, 0..1
			let millis = item.space_millis; // millis to construct label

			const pad = (n, l) => (Math.floor(n) + "").padStart(l || 2, '0');

			line = {
				className: 'entry space',
				style: {
					'background': `rgba(255, 255, 100, ${ratio})`,
				},
				textContent:
					pad(millis / 3600 / 1000) + ':' +
					pad((millis / 60 / 1000) % 60) + ":" +
					pad((millis / 1000) % 60) + "." +
					pad(millis % 1000, 3),
			}
		}
		else if (item.type == 'group') {
			// render log group

			const entries_sorted = item.entries
				.toSorted((a, b) => 
					(this.filterHighlight(b) - this.filterHighlight(a)) ||
					(b.show_priority || 0) - (a.show_priority || 0) || 
					a.ts - b.ts
				);

			const found_msgs = new Set();
			const categories = [];

			const shorts_count = new Map();
			
			const msgs = [];

			let i = 0;
			for (let e of entries_sorted) {
				if (e.category && !categories.find(c => c.category == e.category)) {
					categories.push({
						category: e.category,
						color: e.color
					});
				}
				if (found_msgs.has(e.short)) {
					continue;
				}
				found_msgs.add(e.short);
				let count;
				if (shorts_count.get(e.short)) {
					count = shorts_count.get(e.short);
				} else {
					count = entries_sorted.filter(a => a.short == e.short).length
					shorts_count.set(e.short, count);
				}
				msgs.push({
					color: e.color,
					msg: e.short,
					count
				});
				if (i++ > 10) {
					// drop the rest, for performance reasons
					break;
				}
			}

			line = {
				className: 'entry group ' + (item.entries.some(e => this.filterHighlight(e)) ? 'matched' : ''),
				children: [{
					className: 'ts',
					textContent: Formats.time_millis(entries_sorted[0].ts),
				}, {
					...this.renderPlus(item.entries),
				}, {
					textContent: '',
				}, {
					children: categories.map(c => ({
						nodeName: 'span',
						style: {color: c.color},
						textContent: c.category + ' ',
					})),
					title: categories.map(c => c.category).join(', '),
				}, {
					children: msgs.map(m => ({
						nodeName: 'span',
						style: {color: m.color},
						textContent: (m.count > 1 ? `${m.count}x ` : '') + m.msg + ', ',
					})),
					title: msgs.map(m => m.msg).join('\n'),
				}],
			}
		} else {
			line = this.renderLogEntry(item, item.short);
		}
		
		return {
			style: {
				position: 'absolute',
				top: position + 'px',
				left: 0,
			},
			className: 'line',
			'on:click': (e) => {
				if (item.type !== 'space') {
					e.stopPropagation();
					this.showItem(e.currentTarget, item);
				}
			},
			children: [line],
		};
	},
	
	// TODO call cssVarsColors.clear on theme change
	cssVarsColors: (() => {
		let cache = {};
		return {
			get: v => cache[v] || (cache[v] = Utils.resolveCSSVar(v)),
			clear: () => cache = {},
		};
	})(),
	
	getPriorityColor(priority) {
		const colorsByPriority = {
			'D': this.cssVarsColors.get('var(--table-muted-color)'),
			'V': this.cssVarsColors.get('var(--table-muted-color)'),
			'I': this.cssVarsColors.get('var(--body-fg)'),
			'W': this.cssVarsColors.get('var(--warning)'),
			'E': this.cssVarsColors.get('var(--error)'),
		};
		return colorsByPriority[priority];
	},
	
	getEntryColor(entry) {
		return entry.color || this.getPriorityColor(entry.priority);
	},

	renderLogEntry(entry, short) {
		return {
			className: 'entry ' + (this.filterHighlight(entry) ? 'matched' : ''),
			style: {
				color: this.getEntryColor(entry),
			},
			children: [{
				className: 'ts',
				textContent: Formats.time_millis(entry.ts),
			}, {
				textContent: '',
			}, {
				textContent: entry.priority,
			}, {
				textContent: (entry.tid || '') + ' ' + (entry.tag || ''),
				title:  (entry.tid || '') + ' ' + (entry.tag || ''),
			}, {
				textContent: short || entry.message,
				title: entry.title || entry.message,
			}],
		}
	},
	
	renderPlus(entries) {
		if (!entries || entries.length == 0) {
			return {};
		}
		let counts = {};
		entries.forEach(e => {
			counts[e.priority] = (counts[e.priority] || 0) + 1;
		});
		return {
			children: [{
				nodeName: 'span',
				textContent: '+',
			}, ...('DVIWE'.split('').reverse().filter(p => counts[p]).map(p => ({
				nodeName: 'span',
				style: {color: this.getPriorityColor(p)},
				textContent: counts[p] + ' ',
			})))],
		};
	},
	
	showItem(el, item) {
		const bottom = el.offsetTop + el.offsetHeight;
		
		if (this.itemPopupEl) {
			this.itemPopupEl.remove();
		}
		
		this.entriesEl.gwCreateChild({
			ref: 'itemPopupEl',
			style: {
				top: bottom + 'px',
			},
			'on:wheel': e => e.stopPropagation(),
			className: 'item-popup',
			children: (item.entries || [item]).sort((a, b) => a.ts - b.ts).map(i => this.renderLogEntry(i)),
		}, this);
	},

	async updateMinimap() {
		const ctx = this.minimapCanvasEl.getContext('2d');
		let height = this.minimapCanvasEl.offsetHeight;
		let width = this.minimapCanvasEl.offsetWidth;
		
		this.minimapCanvasEl.height = height;
		this.minimapCanvasEl.width = width;
		
		ctx.clearRect(0, 0, width, height);
		
		if (this.entries_unfiltered.length == 0) {
			return;
		}

		
		// group by pixel
		// -> select main color
		// -> select histogram value
		
		const ts_diff = this.entries_unfiltered[this.entries_unfiltered.length - 1].ts - this.entries_unfiltered[0].ts;

		const groups = this.groupEntriesByTime(
			this.entries_unfiltered, 
			this.entries_unfiltered[0].ts,
			ts_diff,
			height,
			ts_diff / height,
		);

		const entries_length_max = groups
			.map(g => g.type === 'group' ? g.entries.length : 1)
			.reduce((res, cur) => Math.max(res, cur));
		
		const part_width = width * 0.7;

		for (let group of groups) {

			const entries = group.type === 'group' ? group.entries : [group];
			
			const color = entries.some(e => this.filterHighlight(e)) ?
				'yellow' :
				this.getEntryColor(entries.sort((e1, e2) => this.getEntryOrder(e2) - this.getEntryOrder(e1))[0]);

			ctx.fillStyle = color;
			ctx.fillRect(0, group.position, part_width, 1);
			
			ctx.fillStyle = 'black';
			ctx.fillRect(part_width, group.position, Math.pow(entries.length / entries_length_max, 0.5) * (width - part_width), 1);
		}
	}
});

GW.define('Debug.LogsScreen', 'Debug.Screen', {

	source_config: {
		'android': {
			rules: [{
				match: ({priority, message}) => priority === 'E' ? message.split('\n')[0] : false,
				category: 'error',
				short: m => `ERROR: ${m}`,
			}, {
				match: ({priority, message}) => priority === 'W' ? message.split('\n')[0] : false,
				category: 'warn',
				short: m => `WARN: ${m}`,
			}, {
				match: ({message}) => message.match(/^Call state changed, call SIP id = (.+?), call_id = (.+?), state = (.+?)$/),
				category: 'phone',
				short: m => `CALL ${m[3]}`
			}, {
				match: ({message}) => message.match(/^FCM message received {[\s\S]+reason": "(.+?)"/),
				category: 'phone',
				short: m => `FCM ${m[1]}`
			}, {
				match: ({tag, message}) => tag == 'FragmentActivityLogMonitor' && message.match(/^onActivity([^(]+)\(([^),]+)/),
				category: 'ui',
				short: m => m[2].split('.').at(-1) + ' ' + m[1],
			}, {
				match: ({tag, message}) => tag == 'FragmentActivityLogMonitor' && message.match(/^onFragment([^(]+)\(([^),]+)/),
				category: 'ui',
				short: m => m[2].split('.').at(-1) + ' ' + m[1],
			}, {
				match: ({message}) => message.match(/^HTTP request start: 'http.+?\/api\/([^?']+)/),
				category: 'http',
				short: m => `HTTP start ${m[1]}`
			}, {
				match: ({message}) => message.match(/^HTTP request finished .+? 'http.+?\/api\/([^?']+)/),
				category: 'http',
				short: m => `HTTP end ${m[1]}`
			}, {
				match: ({message}) => message.match(/^SIP .+ data sent:\s*(((SIP\/[^ ]+ )(\d+ ))(.+)\s)|(([A-Z]+) ([^ ]+) (SIP\/\S+)\s)/),
				category: 'sip',
				short: m => `SIP > ${((m[4]||'') + (m[5]||'')) || m[7]}`
			}, {
				match: ({message}) => message.match(/^SIP .+ data received:\s*(((SIP\/[^ ]+ )(\d+ ))(.+)\s)|(([A-Z]+) ([^ ]+) (SIP\/\S+)\s)/),
				category: 'sip',
				short: m => `SIP < ${((m[4]||'') + (m[5]||'')) || m[7]}`
			}, {
				match: ({message}) => message.match(/^SIP .+ data sent/),
				category: 'sip',
				short: () => `SIP > data`,
			}, {
				match: ({message}) => message.match(/^SIP .+ data received/),
				category: 'sip',
				short: () => `SIP < data`,
			}, {
				match: ({message}) => message.match(/^Socket onMessage\(\): text: ([\s\S]+)/),
				category: 'ws',
				short: m => `WS < ` + JSON.parse(m[1]).type,
			}],
			'categories': [
				{id: 'error', color: '#ff0000'},
				{id: 'warn', color: '#dc5f00'},
				{id: 'phone', color: '#08a900'},
				{id: 'ui', color: '#0028a4'},
				{id: 'http', color: '#384436'},
				{id: 'sip', color: '#3f3f3f'},
				{id: 'ws', color: '#818181'},
			],
		},
		'ios': {
			rules: [{
				match: ({priority, message}) => priority === 'E' ? message.split('\n')[0] : false,
				category: 'error',
				short: m => `ERROR: ${m}`,
			}, {
				match: ({priority, message}) => priority === 'W' ? message.split('\n')[0] : false,
				category: 'warn',
				short: m => `WARN: ${m}`,
			}, {
				match: ({message}) => message.match(/^Call state changed is (.+?) for user id (.+?) message is (.+?), callId: (.+?)$/),
				category: 'phone',
				short: m => `CALL ${m[1]}`,
				data: m => ({callId: m[4], peer: m[2]}),
			}, {
				match: ({message}) => message.match(/^Linphone: (liblinphone: )?\[PushKit] Notification [\w+] received with payload : \{"/),
				category: 'phone',
				short: (m, {message}) => {
					const mm = message.match(/reason = "([^"]+)"/);
					return `FCM ${mm && mm[2]}`;
				},
			}, {
				match: ({message}) => message.match(/^Linphone: (liblinphone: )?\[Ios App] didEnter(Background|Foreground)/),
				category: 'ui',
				short: m => `-> ${m[2]}`,
			}, {
				match: ({message}) => message.match(/^(BCCP|HTTP) (POST|GET|PUT|PATCH): http.+?\/api\/([^?$]+)/),
				category: 'http',
				short: m => `HTTP start ${m[2]} ${m[3]}`
			}, {
				match: ({message}) => message.match(/^(BCCP|HTTP) (POST|GET|PUT|PATCH) done(: http.+?\/api\/([^?,]+).*?, respose code: (\d+))?/),
				category: 'http',
				short: m => `HTTP end ${m[2]} ${m[4] || ''} ${m[5] || ''}`
			}, {
				match: ({message}) => message.match(/^Linphone: (belle-sip: )?channel \[[^\]]+]: message sent to \[[^\]]+], size: \[\d+] bytes\s*(((SIP\/[^ ]+ )(\d+ ))(.+)\s)|(([A-Z]+) ([^ ]+) (SIP\/\S+)\s)/),
				category: 'sip',
				short: m => `SIP > ${((m[5]||'') + (m[6]||'')) || m[8]}`
			}, {
				match: ({message}) => message.match(/^Linphone: (belle-sip: )?channel \[[^\]]+]: received \[\d+] new bytes from \[[^\]]+]:\s*(((SIP\/[^ ]+ )(\d+ ))(.+)\s)|(([A-Z]+) ([^ ]+) (SIP\/\S+)\s)/),
				category: 'sip',
				short: m => `SIP < ${((m[5]||'') + (m[6]||'')) || m[8]}`,
				data: (m, {message}) => {
					return (/^REGISTER/m.test(message) || /^CSeq: \d+ REGISTER$/m.test(message)) ? {} : ({
						callId: (message.match(/^Call-ID: (.+?)$/m) || [])[1],
						call_id: (message.match(/^P-Ast-Linkedid: (.+?)$/m) || [])[1],
					});
				},
			}, {
				match: ({message}) => message.match(/^Linphone: (belle-sip: )?channel \[[^\]]+]: message sent to \[[^\]]+], size: \[\d+] bytes/),
				category: 'sip',
				short: () => `SIP > data`,
			}, {
				match: ({message}) => message.match(/^Linphone: (belle-sip: )?channel \[[^\]]+]: received \[\d+] new bytes from \[[^\]]+]:/),
				category: 'sip',
				short: () => `SIP < data`,
				data: (m, {message}) => {
					return (/^REGISTER/m.test(message) || /^CSeq: \d+ REGISTER$/m.test(message)) ? {} : ({
						callId: (message.match(/^Call-ID: (.+?)$/m) || [])[1],
						call_id: (message.match(/^P-Ast-Linkedid: (.+?)$/m) || [])[1],
					});
				},
			}, {
				match: ({message}) => message.match(/^Sending websocket message: ([\s\S]+)/),
				category: 'ws',
				short: m => `WS > ` + JSON.parse(m[1]).type,
			}, {
				match: ({message}) => message.match(/^Web[sS]ocket received: ([\s\S]+)/),
				category: 'ws',
				short: m => `WS < ` + JSON.parse(m[1]).type,
			}],
			categories: [
				{id: 'error', color: '#ff0000'},
				{id: 'warn', color: '#dc5f00'},
				{id: 'phone', color: '#08a900'},
				{id: 'ui', color: '#0028a4'},
				{id: 'http', color: '#384436'},
				{id: 'sip', color: '#3f3f3f'},
				{id: 'ws', color: '#818181'},
			]
		}
	},
	
	'after:initComponent'() {
		this.bodyEl.gwReplaceChildren([{
			className: 'timeline-wrap drop-zone',
			children: [{
				ref: 'clientTimeLine',
				xtype: 'Debug.LogsScreen.TimeLine',
				renderNoEntries: () => ({
					className: 'no-entries-upload',
					children: [{
						ref: 'uploadButton',
						nodeName: 'button',
						type: 'button',
						className: 'secondary icon-left',
						children: [Utils.useIcon('upload'), _('Nahrát soubor (.gz nebo jakýkoli text)')],
						'on:click': async ev => {
							ev.preventDefault();

							let file = await Uploads.fileSelect('.gz,.txt,.log,.*');
							if (file) {
								await this.loadFile(file);
							}
						},
					}, {
						className: 'dnd-note',
						textContent: _('Nebo soubor přetáhněte sem'),
					}],
				})
			}],
			'on:dropfiles': async ev => {
				let files = ev.detail.files;
				if (files.length != 1) {
					throw new Error(_('Přetáhnout lze pouze jeden soubor'));
				}
				await this.loadFile(files[0]);
			},
		}], this);
	},

	async applyParams(params) {

	},
	
	
	async loadFile(file) {
		// TODO detect file type, decompress only if gzip
		
		const ds = new DecompressionStream("gzip");
		const decompressedStream = file.stream().pipeThrough(ds);

		// Create a Response from the stream
		const response = new Response(decompressedStream);
		
		const blob = await response.blob();

		const fileContent = await new Promise((res, rej) => {
			const reader = new FileReader();
			reader.onload = e => res(e.target.result);
			reader.onerror = rej;
			reader.readAsText(blob);
		});
		
		// add category, importance, short 
		const tag_log = (entry, source) =>  {
			let show_priority = "DVIWE".indexOf(entry.priority) * 50;
			
			const config = this.source_config[source];
			
			const rules = config.rules;
			const category_colors = Object.fromEntries(config.categories.map(c => [c.id, c.color]))

			for (let i = 0; i < rules.length; i++){
				let rule = rules[i];
				let m = rule.match(entry);
				if (m) {
					if (rule.category) {
						entry.category = rule.category;
						entry.color = category_colors[entry.category];
						entry.show_priority = (rules.length - i) + show_priority;
					}
					entry.short = rule.short ? rule.short(m, entry) : null;
					entry.data = rule.data ? rule.data(m, entry) : {};
				}
			}
		}
		
		const androidLogPattern = /^\[ (\d{2}-\d{2} \d{2}:\d{2}:\d{2}\.\d{3})\s+(\d+):\s*(\d+)\s+([VDIWEF])\/(.+?) ]$/;

		// thanks to Claude
		function parse_android_log(records) {
			const logEntries = [];
			const beginningPattern = /^--------- beginning of (.+)$/;
			let year = new Date().getFullYear();

			const lines = records.join('\n').split('\n');
			let currentEntry = null;
			
			for (let i = 0; i < lines.length; i++) {
				const line = lines[i];
				if (line === '') continue; // TODO empty lines are part of the log, too

				const beginningMatch = beginningPattern.exec(line);
				if (beginningMatch) {
					console.log("Found beginning of section " + beginningMatch[1] + " on line " + (i + 1));
					continue;
				}

				const logMatch = androidLogPattern.exec(line);
				if (logMatch) {
					if (currentEntry) {
						logEntries.push(currentEntry);
					}
					const [, timestamp, pid, tid, priority, tag] = logMatch;
					currentEntry = {
						ts: new Date(year + '-' + timestamp).getTime(), // TODO: fix logs spanning year change
						pid, tid, priority, tag,
						message: '',
					};
				} else if (currentEntry) {
					if (currentEntry.message.length > 0) {
						currentEntry.message += '\n' + line;
					} else {
						currentEntry.message = line;
					}
				} else {
					console.warn("Found unknown data on line " + (i + 1) + ":\n'" + line + "'");
				}
			}

			if (currentEntry) {
				logEntries.push(currentEntry);
			}

			return logEntries;
		}
		
		function parse_ios_log(lines) {
			const logPattern = /^(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}\.\d{3})\s+(\w+)\s*(\w+): ([\s\S]+)$/m;
			
			const parsed = [];
			for (let i in lines) {
				let line = lines[i];
				const match = logPattern.exec(line);

				if (!match) {
					// assume this log line belongs to the previous one
					if (parsed.length == 0) {   
						// no last parsed line
						console.warn(`Found unparsable data for line ${i}:\n${line}`);
					} else {
						parsed[parsed.length - 1].message += "\n" + line;
					}
					continue;
				}

				const [, timestamp, priority, tid, message] = match;
				parsed.push({
					ts: new Date(timestamp).getTime(),
					priority,
					tid,
					message,
				});
			}
			return parsed;
		}
		
		let platform;
		let records;
		
		let type; // 'calllog', 'bugreport'
		let metadata;
		
		if (fileContent[0] == '{') {
			
			// assume JSON gzipped mobile app log
			// TODO read and show other fields from json (message, ts, cid, deviceId, ua, user)
			
			const jsonEndIndex = fileContent.indexOf('\n}\n\n');
			if (jsonEndIndex >= 1) {
				// assume calllog
				const json = JSON.parse(fileContent.substring(0, jsonEndIndex + 2));
				const lines = fileContent.substring(jsonEndIndex + 4);
				
				type = 'calllog';
				metadata = json;
				records = lines.split('\n');

				// heuristic for source detection
				platform = new RegExp(androidLogPattern, 'm').exec(lines) ? 'android' : 'ios';
			} else {
				// assume bugreport
				const json = JSON.parse(fileContent);

				type = 'bugreport';
				({records, ...metadata} = json);

				if (json.ua.includes('android')) {
					platform = 'android';
				} else if (json.ua.includes('iOS')) {
					platform = 'ios';
				} else {
					throw "Could not detect logs platform (android or ios) from ua: " + json.ua;
				}
			}
			
		} else {
			// assume lines of texts
			throw "Unknown logs format";
			// TODO parse the lines - detect server log or android log?
		}
		
		const log_entries = ({
			'android': parse_android_log,
			'ios': parse_ios_log,
		}[platform] || (f => { throw 'Unknown format: ' + f }))(records);

		log_entries.forEach(e => {
			tag_log(e, platform);
			if (!e.short) {
				e.short = e.message.split('\n')[0];
			}
		});

		this.clientTimeLine.setCategories(this.source_config[platform].categories);
		this.clientTimeLine.setEntries(type, metadata, log_entries);
		
		// TODO load server logs like this:
		// const since = log_entries[0].ts;
		// const until = log_entries[log_entries.length - 1].ts;
		// REST.GET('debug/server-log', {since, until}).then(logs => {
		// 	this.serverTimeLine.setEntries(logs);
		// });
	}
});


// }}}

// {{{ Routes

if (env.DEBUG_PANEL) {
	Application.addRoutes([{
		group: 'auth',
		module: 'debug',
		path: APP_BASE + 'debug/calls',
		async handler({params, captures}) {
			let c = Application.show({
				id: 'debug.calls',
				xtype: 'Debug.CallsScreen',
			});

			c.setData(await REST.GET('debug/calls'));
		},
	}, {
		group: 'auth',
		module: 'debug',
		path: APP_BASE + 'debug/scenarios',
		async handler({params, captures}) {
			let c = Application.show({
				id: 'debug.scenarios',
				xtype: 'Debug.CallsScreen',
				async getCallEvents(id) {
					return await REST.GET('debug/scenarios/events', {id});
				},
			});

			c.setData(await REST.GET('debug/scenarios'));
		},
	}, {
		group: 'auth',
		module: 'debug',
		path: APP_BASE + 'debug/state',
		async handler({params, captures}) {
			let c = Application.show({
				xtype: 'Debug.StateScreen',
			});

			c.reload();
		},
	}, {
		group: 'auth',
		module: 'debug',
		path: APP_BASE + 'debug/bugreports',
		async handler({params, captures}) {
			let c = Application.show({
				xtype: 'Debug.BugreportsScreen',
			});

			c.applyParams(params);
		},
	}, {
		group: 'auth',
		module: 'debug',
		path: APP_BASE + 'debug/calllogs',
		async handler({params, captures}) {
			let c = Application.show({
				xtype: 'Debug.CallLogsScreen',
			});

			c.applyParams(params);
		},
	}, {
		group: 'auth',
		module: 'debug',
		path: APP_BASE + 'debug/sipproxyregs',
		async handler({params, captures}) {
			let c = Application.show({
				xtype: 'Debug.MobileRegistrationsScreen',
			});

			c.applyParams(params);
		},
	}, {
		group: 'auth',
		module: 'debug',
		path: APP_BASE + 'debug/logs',
		async handler({params, captures}) {
			let c = Application.show({
				xtype: 'Debug.LogsScreen',
			});

			c.applyParams(params);
		},
	}, {
		group: 'auth',
		module: 'debug',
		path: APP_BASE + 'debug/loopback',
		async handler({params, captures}) {
			let c = Application.show({
				xtype: 'Debug.LoopbackScreen',
			});
		},
	}, {
		group: 'auth',
		module: 'debug',
		path: APP_BASE + 'debug',
		async handler({params, captures}) {
			Application.replaceRoute(APP_BASE + 'debug/state');
		},
	}]);

	Application.registerModule({
		id: 'debug',
		title: _('Debugovací panel'),
		tagline: _('Ladění systému'),
		icon: 'bug',
		href: APP_BASE + 'debug',
	});
}

// }}}
